import { Box } from "@material-ui/core";

const FlexDivider = () => (
  <Box component="span" flex={1}/>
);

export default FlexDivider;